import { ProgressCircle } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import React from 'react';

export interface OnboardingPillProps {
  isActive: boolean;
  isExpanded: boolean;
  onClick: () => void;
  className?: string;
}

const OnboardingPill = React.forwardRef<HTMLButtonElement, OnboardingPillProps>(
  ({ isExpanded, onClick, className, isActive }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        className={cn(
          'group relative overflow-hidden w-full text-left rounded-full bg-white transition-all border-fg-brand border-[0.5px] hover:bg-bg-brand shrink-0',
          isActive && 'ring-4 ring-[var(--color-bg-brand-hover)] bg-bg-brand',
          isExpanded
            ? 'px-md py-md'
            : 'group-data-[collapsible=icon]:!w-7 group-data-[collapsible=icon]:!h-7 group-data-[collapsible=icon]:!p-0 group-data-[collapsible=icon]:flex group-data-[collapsible=icon]:items-center group-data-[collapsible=icon]:justify-center border-bg-brand border',
          className
        )}
      >
        {isExpanded ? (
          <div className="relative flex items-center gap-2">
            <ProgressCircle value={50} variant="success" />
            <span className="txt-extra-small-medium text-fg-brand">
              Onboarding
            </span>
          </div>
        ) : (
          <ProgressCircle value={50} variant="success" />
        )}
      </button>
    );
  }
);

OnboardingPill.displayName = 'OnboardingPill';

export { OnboardingPill };
